<template>
  <div>
    <div class="form-group">
      <label for="query">
        <strong>PRINCÍPIO ATIVO</strong>
        <strong>
          <code>*</code>
        </strong>
      </label>
      <span class="ml-2 text-muted">Digite para pesquisar</span>
      <input
        :disabled="disabled"
        placeholder="Digite para pesquisar"
        class="form-control"
        list="active_ingredients"
        v-model="query"
        id="query"
        name="query"
        v-on:input="getActiveIngredientsLike"
        autocomplete="off"
        :ref="refautofocus ? 'autofocus' : ''"
      />
      <datalist id="active_ingredients">
        <option
          v-for="active_ingredient in active_ingredients"
          :key="active_ingredient.id"
          :value="`(${active_ingredient.id}) ${active_ingredient.name}`"
        >
          {{ `(${active_ingredient.id}) ${active_ingredient.name}` }}
        </option>
      </datalist>
    </div>
  </div>
</template>


<script>
import api from "../../services/api";
import { numbersOnly } from "../../lib/format";

export default {
  name: "SelectActiveIngredientID",
  props: {
    value: [String, Number],
    refautofocus: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      active_ingredient_id: undefined,
      query: undefined,
      active_ingredients: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      try {
        if (!this.value) {
          return;
        }

        this.active_ingredient_id = this.value;

        let params = { id: this.active_ingredient_id };
        let response = await api.get("/rest-home/active-ingredient", {
          params,
        });

        const { error, errors, active_ingredient } = response.data;
        if (error) {
          console.log(errors);
        } else {
          this.query = `(${active_ingredient.id}) ${active_ingredient.name}`;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getActiveIngredientsLike() {
      this.active_ingredient_id = numbersOnly(this.query.split(") ", 1)[0]);
      this.$emit("input", this.active_ingredient_id);

      if (this.query.length > 0) {
        let { query } = this;
        query = this.query.replace(`(${this.active_ingredient_id}) `, "");

        let params = { query };

        const response = await api.get("/rest-home/active-ingredients", {
          params,
        });

        const { error, active_ingredient } = response.data;

        if (!error) {
          this.active_ingredients = active_ingredient;
        }
      }
    },
  },
};
</script>
